<template>
    <section>
        <div class="container container-app">
            <section class="position-relative">
                <div class="mt-5 mb-5">
                    <h3 class="login-title text-center mt-5">{{ $t('reset.reset_title') }}</h3>
                </div>
                <form @submit="doReset">
                    <div class="form-group position-relative">
                        <span class="login-input-title float-left">{{ $t('reset.password') }}</span>
                        <input type="password" class="form-control form-control--canvassing border-bottom" :placeholder="$t('reset.password_placeholder')" v-model="form.password" id="password">
                        <div v-if="hasError(errors, 'password')">
                            <span class="text-danger">{{errors.password[0]}}</span>
                        </div>
                    </div>
                     <div class="form-group position-relative">
                        <span class="login-input-title float-left">{{ $t('reset.confirm_password') }}</span>
                        <input type="password" class="form-control form-control--canvassing border-bottom" :placeholder="$t('reset.confirm_password_placeholder')" v-model="form.confirm_password" id="confirm_password">
                        <div v-if="hasError(errors, 'confirm_password')">
                            <span class="text-danger">{{errors.confirm_password[0]}}</span>
                        </div>
                    </div>

                    <button type="submit" class="btn shadow btn-app btn-block mb-5 mt-5 primaryBackground">{{ $t('reset.reset_password_button') }}</button>
                </form>
            </section>
        </div>
    </section>
</template>

<script>
    import HelperMixin from "../../mixins/HelperMixin";

    export default {
        name: "Reset",
        mixins: [HelperMixin],
        created() {
            this.form.token = this.tokenParam;
        },
        data() {
            return {
                form: {
                    token: '',
                    password: "",
                    confirm_password: "",
                },
                errors: {
                     password: [],
                     confirm_password: [],
                }
            }
        },
        methods: {
            resetErrors() {
                 this.errors = {
                     password: [],
                     confirm_password: [],
                };
            },

            resetForm() {
                this.form = {
                    token: this.tokenParam,
                    password: "",
                    confirm_password: "",
                };
            },

            doReset(evt) {
                evt.preventDefault();
                if (!this.$store.getters['online']) {
                    $('#featureUnavailableOfflineModal').modal('show');
                    return false;
                }
                this.$store.dispatch('saveIsLoading', {
                    isLoading: true
                });
                this.resetErrors();
                let config = {
                };

                axios.post(
                        this.apiUrl,
                        this.form,
                        config
                ).then(this.consumedoReset, this.errordoReset);
            },

            consumedoReset: function (response) {
                this.$store.dispatch('showForgotMessage', {
                    showForgotMessage: false
                });
                this.$store.dispatch('showConfirmMessage', {
                    showConfirmMessage: false
                });
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });

                this.resetForm();
                
                this.$router.replace({ name: "login"});
            },

            errordoReset: function (error) {
                this.$store.dispatch('saveIsLoading', {
                    isLoading: false
                });
                if (
                    error.response !== undefined &&
                    error.response.data !== undefined &&
                    error.response.data.responseType === 'Error' &&
                    error.response.data.errorMessage !== undefined 
                ) {
                    if (typeof error.response.data.errorMessage.validation_fail != 'undefined') {
                        if (typeof error.response.data.errorMessage.validation_fail.password != 'undefined') {
                            if (error.response.data.errorMessage.validation_fail.password.includes("required")) {
                                this.errors.password = [this.$t('reset.errors.password_required')];
                            }
                        }
                        if (typeof error.response.data.errorMessage.validation_fail.confirm_password != 'undefined') {
                            if (error.response.data.errorMessage.validation_fail.confirm_password.includes("required")) {
                                this.errors.confirm_password = [this.$t('reset.errors.confirm_password_required')];
                            }
                            if (error.response.data.errorMessage.validation_fail.confirm_password.includes("incorrect")) {
                                this.errors.confirm_password = [this.$t('reset.errors.confirm_password_incorrect')];
                            }
                        }
                        if (typeof error.response.data.errorMessage.validation_fail.token != 'undefined') {
                            if (error.response.data.errorMessage.validation_fail.token.includes("invalid")) {
                                this.errors.confirm_password = [this.$t('reset.errors.token_invalid')];
                            }
                            if (error.response.data.errorMessage.validation_fail.token.includes("required")) {
                                this.errors.confirm_password = [this.$t('reset.errors.token_invalid')];
                            }
                        }
                    }
                }
                console.log(error);
            },
        },

        computed: {
            tokenParam() {
                if (typeof this.$route.params.token != 'undefined') {
                    return this.$route.params.token;
                } else if (typeof this.$store.getters["token"] != 'undefined' &&  this.$store.getters["token"]) {
                    return this.$store.getters["token"];
                } else {
                    return '';
                }
            },
            apiUrl () {
                if (typeof this.$route.params.token != 'undefined') {
                    return '/api/v1/user/reset';
                } else {
                    return '/api/v1/user/update';
                } 
            }
        }
    };
</script>
